"use strict";

/**
 * General (non-project-specific) utility functions.
 */ 
export default class Util {

  /**
   * Adopted from https://stackoverflow.com/a/901144
   */
  static getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2] || results[2] === "null") {
      return null;
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  /**
   * From https://stackoverflow.com/a/25214672
   */
  static removeParameterFromUrl(url, parameter) {
    return url
        .replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1')
        .replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
  }


  static setTransform(el, stringValue) {
    $(el).css('transform', stringValue);
    $(el).css('-moz-transform', stringValue);
    $(el).css('-o-transform', stringValue);
    $(el).css('-ms-transform', stringValue);
    $(el).css('-webkit-transform', stringValue);
  }

  /**
   * Rem, this will clobber any other transforms besides scale.
   */
  static setScale(el, scale) {
    Util.setTransform(el, 'scale(' + scale + ", " + scale + ')');
  }

  /**
   * Rem, this will clobber any other transforms besides translation.
   */
  static setTranslation(el, x, y) {
    const s = `translate(${x}px, ${y}px)`;
    Util.setTransform(el, s);
  }

  static setTranslationAndScale(el, x, y, scale) {
    const s = `translate(${x}, ${y}) scale(${scale}, ${scale})`;
    Util.setTransform(el, s);
  }

  /**
   * Replaces occurrences of keys with values.
   */
  static stringReplaceKeysWithValues(string, object) {
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        const value = object[key];
        string = Util.stringReplaceAll(string, key, value);
      }
    }
    return string;
  }

  static stringReplaceAll(str,replaceWhat,replaceTo) {
    replaceWhat = replaceWhat.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    var re = new RegExp(replaceWhat, 'g');
    return str.replace(re,replaceTo);
  }

  static escapeStringForHtmlOutput(unsafe) {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
  }

  static getCssTranslation($el) {
    const a = $el.css('transform').replace(/[^0-9\-.,]/g, '').split(',');
    const x = parseFloat(a[4]);
    const y = parseFloat(a[5]);
    return { x: x, y: y };
  }

  // ---
  // Math

  static clamp(value, min, max) {
    if (value < min) {
      value = min;
    } else if (value > max) {
      value = max;
    }
    return value;
  }

  static lerp(normValue, minimum, maximum) {
    return minimum + (maximum - minimum) * normValue;
  }

  static lerpRect(normValue, rect1, rect2, destRect) {
    destRect.x = Util.lerp(normValue, rect1.x, rect2.x);
    destRect.y = Util.lerp(normValue, rect1.y, rect2.y);
    destRect.width = Util.lerp(normValue, rect1.width, rect2.width);
    destRect.height = Util.lerp(normValue, rect1.height, rect2.height);
  }

  static normalize(value, minimum, maximum) {
    return (value - minimum) / (maximum - minimum);
  }

  static map(value, min1, max1, min2, max2) {
    const val = Util.lerp(Util.normalize(value, min1, max1), min2, max2);
    return val;
  }

  static pointLength(x, y) {
    return Math.sqrt(x * x + y * y);
  }

  static distance(x1, y1, x2, y2) {
    const x = x2 - x1;
    const y = y2 - y1;
    return Math.sqrt(x * x + y * y);
  }

  /**
   * @returns number where 0 = up, going counter-clockwise
   */
  static getAngle(x, y) {
    // note the atan2 call, the order of paramers is y then x
    const radians = 1.5 * Math.PI - Math.atan2(y, x);
    let degrees = radians / Math.PI * 180;
    return degrees % 360;
  }

  static normalizePoint(point, magnitude) {
    const len = Util.pointLength(point.x, point.y);
    const mult = magnitude / len;
    point.x *= mult;
    point.y *= mult;
  }

  /**
   * Unselects any selected text, etc.
   */
  static windowUnselect() {
    const sel = window.getSelection ? window.getSelection() : document.selection;
    if (sel) {
      if (sel.removeAllRanges) {
        sel.removeAllRanges();
      } else if (sel.empty) {
        sel.empty();
      }
    }
  }

  /**
   * Tests if LocalStorage is available
   * (ie, browser is not blocking "third party cookies" etc.)
   */
  static get isLocalStorageAvailable() {
    try {
      const dummyItem = localStorage.getItem("anything");
    } catch (error) {
      return false;
    }
    return true;
  }

  /**
   * Use this for "aria-hidden" rather than setting the attribute directly.
   * When set to false, it removes the attribute altogether because setting it to
   * false explicitly can cause unintended browser side effects, I think.
   */
  static setAriaHidden($el, b) {
    if (b) {
      $el.attr("aria-hidden", "true");
    } else {
      $el.removeAttr("aria-hidden");
    }
  }

  /** See https://stackoverflow.com/a/11752084 */
  static get isMac() {
    return navigator.platform.toUpperCase().indexOf('MAC')>=0;
  }

  /**
   * If Mac, attempts to make scrollbar appear momentarily by scrolling element 1px down and then back up.
   */
  static flashMacScrollbar($scrollableEl) {
    if (!Util.isMac) {
      return;
    }
    const value = $scrollableEl.scrollTop();
    $scrollableEl.scrollTop(value + 1).scrollTop(value);
  }
}
